module.exports = __webpack_public_path__ + "img/22.9f9da36f.svg";